import { jsx as r, jsxs as l } from "react/jsx-runtime";
import { Center as d, VStack as c } from "@chakra-ui/react";
import { Td as m } from "../Td/Td.mjs";
import { Tr as p } from "../Tr/Tr.mjs";
import { Typography as g } from "../../Typography/Typography.mjs";
import { TriangleExclamationIcon as h, FilterIcon as y, MagnifyingGlassIcon as f } from "../../../icons/componentIcons.mjs";
const i = ({ addOn: o, content: t, heading: e, icon: n }) => /* @__PURE__ */ l(c, { spacing: 4, children: [
  n,
  /* @__PURE__ */ l(c, { spacing: 1, children: [
    /* @__PURE__ */ r(g, { variant: "subheading2", children: e }),
    /* @__PURE__ */ r(g, { children: t })
  ] }),
  o
] }), R = ({
  colSpan: o = 1,
  addOn: t,
  error: e,
  searchTerm: n,
  showPaginationFooter: a,
  isMobile: s
}) => /* @__PURE__ */ r(p, { children: /* @__PURE__ */ r(
  m,
  {
    colSpan: o,
    p: "0",
    ...a ? { borderBottomRadius: "none" } : { borderBottomRadius: "lg" },
    children: /* @__PURE__ */ r(
      d,
      {
        bg: "gray.100",
        py: "46px",
        px: 6,
        ...s && !a ? { borderBottomRadius: "lg" } : { borderBottomRadius: "none" },
        children: e ? /* @__PURE__ */ r(
          i,
          {
            addOn: t,
            icon: /* @__PURE__ */ r(h, { size: "4xl", color: "red.500", variant: "light" }),
            heading: "Something went wrong!",
            content: "Please try again later."
          }
        ) : n ? /* @__PURE__ */ r(
          i,
          {
            addOn: t,
            icon: /* @__PURE__ */ r(y, { size: "4xl", variant: "light" }),
            heading: `No results for "${n}" found!`,
            content: "Broaden your filter settings or try searching for something else."
          }
        ) : /* @__PURE__ */ r(
          i,
          {
            addOn: t,
            icon: /* @__PURE__ */ r(f, { size: "4xl", variant: "light" }),
            heading: "No data yet!",
            content: "Try searching or adding new content."
          }
        )
      }
    )
  }
) });
export {
  R as TableEmptyState
};
